<template>
    <div class="ui__268VTip_main">
        <div class="ui__268VTip_cover">
        </div>
        <div class="ui__268VTip_left">
            <img src="../../../assets/image/Subtract.png">
            <span>此车已通过268V检测认证</span>
        </div>
        <div class="ui__268VTip_right">
            <span>NO.{{state.reportCode}}</span>
        </div>
    </div>
</template>

<script>
    import {defineComponent, reactive} from 'vue'
    import {useRoute} from 'vue-router'

    export default defineComponent({
        name: "268VTip",
        setup() {
            let state = reactive({
                reportCode: '',
            })
            let route = useRoute()
            state.reportCode = route.query.reportCode
            return {
                state
            }
        }
    })
</script>

<style scoped lang="less">
    .ui__268VTip_main {
        padding: 0.09rem 0.16rem;
        /*height: 0.32rem;*/
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 12px;
        color: #6E6E6E;
        position: relative;
        top: -0.02rem;

        .ui__268VTip_cover {
            position: absolute;
            left: 0;
            /*margin-bottom: 0.02rem;*/
            width: 100%;
            height: 0.34rem;
            z-index: 0;
            background: linear-gradient(270.04deg, #0AB964 0.01%, rgba(10, 185, 100, 0.56) 99.95%);
            opacity: 0.2;
        }

        .ui__268VTip_left {
            img {
                width: 0.12rem;
                height: 0.13rem;
                position: relative;
                top: 0.02rem;
            }

            span {
                margin-left: 0.04rem;
            }
        }
    }
</style>
